import { withInstall } from '@ll-plus/utils'

import IconBasePro from './src/icon-base-pro.vue'

export const LlIconBasePro = withInstall(IconBasePro)
export default LlIconBasePro
export * from './src/icon-base-pro'

declare module 'vue' {
  export interface GlobalComponents {
    LlIconBasePro: typeof IconBasePro
  }
}
